import UaParser from 'ua-parser-js'

/**
 * 检测当前浏览器或应用是否在允许的白名单内
 * @returns {boolean} 如果当前浏览器或应用在白名单内，返回 `true`，否则返回 `false`
 */
export const detectEnvironment = () => {
  const uaParser = new UaParser()
  const uaInfo = uaParser.getResult()
  const browserName = uaInfo.browser.name || '' // 浏览器名称
  const userAgent = uaInfo.ua || '' // 完整的 User-Agent 字符串

  // 白名单：主流浏览器及应用
  const browserAppWhitelist: { [key: string]: string } = {
    // 浏览器白名单
    Chrome: '谷歌浏览器',
    'Chrome WebView': '谷歌浏览器',
    Safari: '苹果浏览器',
    'Mobile Safari': '苹果浏览器',
    Firefox: '火狐浏览器',
    Edge: 'Edge 浏览器',
    'Samsung Internet': '三星浏览器',
    Opera: 'Opera 浏览器',
    'QQ Browser': 'QQ 浏览器',
    Quark: '夸克浏览器',
    HuaweiBrowser: '华为浏览器',
    MiuiBrowser: '小米、红米浏览器',
    OppoBrowser: 'OPPO、一加浏览器',
    VivoBrowser: 'vivo 浏览器',
    FlymeBrowser: '魅族浏览器',
    AsusBrowser: '华硕浏览器',
    RealmeBrowser: 'Realme 浏览器',
    LenovoBrowser: '联想浏览器',
    InfinixBrowser: 'Infinix 浏览器',
    TecnoBrowser: 'Tecno 浏览器',
    NokiaBrowser: '诺基亚浏览器',
    HonorBrowser: '荣耀浏览器',
    '360 Browser': '360 浏览器',
    UCBrowser: 'UC 浏览器',
    AndroidWebView: 'Android WebView',
    Brave: 'Brave 浏览器',
    Vivaldi: 'Vivaldi 浏览器',
    YandexBrowser: 'Yandex 浏览器',
    PaleMoon: 'Pale Moon 浏览器',
    EpicBrowser: 'Epic 浏览器',
    InternetExplorer: 'Internet Explorer 浏览器',
    Maxthon: 'Maxthon 浏览器',

    // 应用白名单
    Tinder: 'Tinder',
    Bumble: 'Bumble',
    Grindr: 'Grindr',
    Hinge: 'Hinge',
    OkCupid: 'OkCupid',
    'Facebook Browser': 'Facebook',
    'Instagram Browser': 'Instagram',
    XiaoHongShu: '小红书',
    Feishu: '飞书',
    Lark: '飞书（国际版）',
    'Douyin Browser': '抖音浏览器',
    'TikTok Browser': 'TikTok（抖音国际版）浏览器',
    'LINE Browser': 'LINE 浏览器',
    'Twitter Browser': '推特浏览器',
    'WhatsApp Browser': 'WhatsApp 浏览器',
    'Telegram Browser': 'Telegram 浏览器',
    'Snapchat Browser': 'Snapchat 浏览器',
    'YouTube Browser': 'YouTube 浏览器',
    'weelife Browser': 'weelife 浏览器'
  }

  // 定义应用检测规则
  const appRegex: { [key: string]: RegExp } = {
    Facebook: /FBAN|FBAV/,
    Instagram: /instagram/i,
    Douyin: /douyin|douyinbrowser/,
    TikTok: /tiktok|tiktokbrowser/,
    LINE: /Line\/|LineBrowser/i,
    Twitter: /Twitter/i,
    WhatsApp: /WhatsApp/i,
    Telegram: /Telegram/i,
    Snapchat: /Snapchat/i,
    YouTube: /YouTube/i,
    weelife: /weelife/i
  }

  // 检测是否是应用
  const detectedApp = Object.keys(appRegex).find(app => appRegex[app].test(userAgent))
  const appName = detectedApp ? `${detectedApp} Browser` : null

  console.log(`browserName: ${browserName}`)
  console.log(`appName: ${appName}`)

  // 判断是否在浏览器白名单或应用白名单内
  const isWhitelisted = Object.keys(browserAppWhitelist).some(key =>
    key.includes(browserName) || (appName && key.includes(appName))
  )

  console.log(`isWhitelisted: ${isWhitelisted}`)

  return isWhitelisted
}
